module.exports = __webpack_public_path__ + "img/kleisma2-m@2.a64d3f44.webp";